exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/modules/_wks-ext.js
// module id = xxwE
// module chunks = a74a